import type { RawProductQuery } from '@packages/gql/generated/shopping/graphql';

export type DimensionsForTracking = NonNullable<RawProductQuery['product']>['dimensions'];

export function getAddToBasketColorString(dimensions: DimensionsForTracking) {
  return (
    dimensions
      .filter((dimension) => dimension?.axisType === 'COLOR')
      .pop()
      ?.values.filter((value) => value.isSelected === true)
      .map((selectedValue) => selectedValue.displayText)
      .join('') ?? ''
  );
}
